import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Vue from 'vue'

const state = {
  categoryName: 'スマホアプリマスタ',

  // model
  spAppMstModel: []
}

const getters = {
  get: state => state
}

const actions = {
  /**
   * 初期データを読出し
   */
  loadModel ({commit}, {spAppMstParams}) {
    console.log(9)
    return new Promise((resolve, reject) => {
      // ApiManager.request(
      //   ['spAppMst'],
      //   ['v1SpAppMstGet'],
      //   [spAppMstParams])
      //   .then(res => {
      //     let status = Utility.parseResponse(res)

      //     if (status.result) {
      //       commit('setSpAppMstModel', res[0].data.spAppMsts)
      //       console.log('spAppMstModel', state.spAppMstModel)
      //       resolve()

      //     } else if (status.error) {
      //       // エラーメッセージ表示
      //       reject(res)
      //     } else {
      //       // アプリケーションエラー表示
      //       reject(null)
      //     }
      //   })
      //   .catch(error => {
      //     // アプリケーションエラー表示
      //     reject(null)
      //   })
      ApiManager.request(
        ['spAppMst'],
        ['v1SpAppMstLatestGet'],
        [spAppMstParams])
        .then(res => {
          let status = Utility.parseResponse(res)

          if (status.result) {
            commit('setSpAppMstModel', res[0].data.spAppMsts)
            console.log('spAppMstModel', state.spAppMstModel)
            resolve()

          } else if (status.error) {
            // エラーメッセージ表示
            reject(res)
          } else {
            // アプリケーションエラー表示
            reject(null)
          }
        })
        .catch(error => {
          // アプリケーションエラー表示
          reject(null)
        })
    })
  }
}

const mutations = {
  // model
  setSpAppMstModel (state, data) {
    // data.sort(Utility.sortByKey('spAppMstId', false))
    Vue.set(state, 'spAppMstModel', [data])
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
